import { withI18n } from 'lingui-react';

function WithI18n({ i18n, render }) {
  return render({
    i18n,
  });
}

export default withI18n()(WithI18n);



// WEBPACK FOOTER //
// ./src/components/WithI18n/index.js